import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
// import * as Cookies from 'js-cookie';
import modules from './modules';
import createLoginHook from './plugins/loginHook';
import http from '@/http';

Vue.use(Vuex);

const buildStore = (router) => {
  const store = new Vuex.Store({
    modules,
    plugins: [
      createPersistedState({
        key: 'tcloud-2019',
        paths: [
          'Session.token',
          'Session.userPreferences',
        ],
      }),
      createLoginHook(router, http),
    ],
  });

  return store;
};

export default buildStore;
